import { MultiSelectChips } from '@/components/shared/multi-select-chips';
import {
  BaseQuestion,
  type BaseQuestionProps,
} from '@/packages/profile-quiz/components/questions/base-question';

interface SelectQuestionProps<T = string>
  extends Omit<BaseQuestionProps, 'children'> {
  handleToggleAnswer: (answer: T) => void;
  currentValues?: T[] | null;
  options: {
    label: string;
    value: T;
  }[];
}

export const SelectQuestion = <T = string,>({
  questionTitle,
  processedResponseText,
  questionId,
  handleToggleAnswer,
  currentValues,
  options,
}: SelectQuestionProps<T>) => (
  <BaseQuestion
    questionTitle={questionTitle}
    processedResponseText={processedResponseText}
    questionId={questionId}
  >
    <MultiSelectChips
      options={options}
      currentValues={currentValues}
      onToggle={handleToggleAnswer}
    />
  </BaseQuestion>
);
